import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";

const AvisoLegal = () => {
  useEffect(() => {
    document.title = "Aviso legal · PORT'S COLLECTORS";
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div data-testid="page-aviso-legal" className="bg-white min-h-screen">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          <Link to="/">
            <Logo />
          </Link>
          <Link
            to="/"
            data-testid="back-home"
            className="text-sm text-ink-muted hover:text-navy inline-flex items-center gap-2"
          >
            <ArrowLeft size={16} /> Volver
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="text-xs uppercase tracking-[0.22em] text-sky font-semibold mb-4">
          Información legal
        </div>
        <h1 className="font-display text-4xl lg:text-5xl text-navy leading-tight tracking-tight">
          Aviso legal
        </h1>

        <div className="mt-10 space-y-8 text-ink-muted leading-relaxed">
          <section>
            <h2 className="font-display text-xl text-navy mb-3">1. Datos del titular</h2>
            <p>
              En cumplimiento de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la
              Información y de Comercio Electrónico (LSSI-CE), se informa de los siguientes datos
              identificativos:
            </p>
            <ul className="mt-4 space-y-1.5 text-sm bg-surface-alt border border-slate-200 rounded-sm p-5">
              <li><strong className="text-navy">Denominación social:</strong> PORT&rsquo;S DEBT COLLECTION S.L.</li>
              <li><strong className="text-navy">CIF:</strong> B16935785</li>
              <li><strong className="text-navy">Domicilio:</strong> C/ María de Molina nº 60, 28006 Madrid</li>
              <li><strong className="text-navy">Correo electrónico:</strong> abogados@portsdebt.es</li>
              <li><strong className="text-navy">Web:</strong> portsdebt.es</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl text-navy mb-3">2. Objeto</h2>
            <p>
              El presente sitio web tiene carácter institucional e informativo y está orientado a
              dar a conocer los servicios profesionales prestados por PORT&rsquo;S COLLECTORS en el
              ámbito del Derecho marítimo, portuario y mercantil.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-navy mb-3">3. Propiedad intelectual</h2>
            <p>
              Los contenidos, diseños, textos, marcas y signos distintivos incluidos en este sitio
              web son titularidad de PORT&rsquo;S DEBT COLLECTION S.L. o cuentan con la
              autorización correspondiente para su uso. Queda prohibida su reproducción total o
              parcial sin autorización expresa.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-navy mb-3">4. Responsabilidad</h2>
            <p>
              El titular no se hace responsable de la información publicada en sitios web de
              terceros enlazados desde este sitio, ni del uso indebido que pueda hacerse de los
              contenidos por parte de los usuarios.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-navy mb-3">5. Legislación aplicable</h2>
            <p>
              El presente aviso legal se rige por la legislación española. Para la resolución de
              cualquier controversia derivada del acceso o uso del sitio web, las partes se someten
              a los Juzgados y Tribunales de Madrid.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default AvisoLegal;
